var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: "",
            "hide-overlay": "",
            dark: "",
            transition: "dialog-bottom-transition",
            scrollable: ""
          },
          model: {
            value: _vm.visibility,
            callback: function($$v) {
              _vm.visibility = $$v
            },
            expression: "visibility"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { tile: "" } },
            [
              _c(
                "v-toolbar",
                { attrs: { card: "", color: "tertiary" } },
                [
                  _c("v-toolbar-title", [_vm._v("Usage Manual")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: { click: _vm.updateVisibility }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              [
                _c(
                  "v-expansion-panel",
                  { attrs: { focusable: "" } },
                  _vm._l(_vm.helpTopics, function(help, i) {
                    return _c(
                      "v-expansion-panel-content",
                      { key: i },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [_vm._v(_vm._s(help.topic))]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card",
                          [
                            _c(
                              "v-card-text",
                              {
                                staticClass: "grey lighten-4",
                                domProps: { innerHTML: _vm._s(help.content) }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(help.content) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  1
                )
              ]
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a005f20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a005f20","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpMenu.vue
// module id = null
// module chunks = 